import { jsx as t } from "react/jsx-runtime";
import { Typography as o } from "../../../../dataDisplay/Typography/Typography.mjs";
import { ErrorMessage as i } from "../../../ErrorMessage/ErrorMessage.mjs";
import { getFileUploadItemStatusText as m } from "../../fileUploadFunctions.mjs";
const n = ({ status: e, error: r }) => r ? /* @__PURE__ */ t(i, { children: r }) : /* @__PURE__ */ t(
  o,
  {
    variant: "bodySmall",
    ...e === "success" ? { color: "green.500" } : { type: "secondary" },
    children: m(e)
  }
);
export {
  n as default
};
